export default function (oldCart = null) {
  if (oldCart) {
    this.products = oldCart.products
    this.totalPrice = oldCart.totalPrice
  } else {
    this.totalPrice = 0
    this.products = []
  }

  this.addToCart = (data) => {
    this.products.push({
      product: data.product,
      size: data.size
    })
    this.totalPrice += data.product.price
  }
  this.remove = (productId, size) => {
    const index = this.products.findIndex(x => x.product._id === productId && x.size === size)
    this.totalPrice -= this.products[index].product.price
    this.products.splice(index, 1)
  }
}
